import React from 'react';
import { cn } from '@/lib/utils';

export const Spinner = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        className={cn("animate-spin rounded-full border-2 border-current border-t-transparent h-4 w-4", className)}
        ref={ref}
        role="status"
        aria-label="Loading"
        {...props}
      >
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
);

Spinner.displayName = 'Spinner'; 